import React, { createContext, useContext } from 'react';
import { SsrProvider } from './SsrProvider.js';
import { DEFAULT_THEME } from './default-theme.js';
import { mergeTheme } from './utils/merge-theme/merge-theme.js';

const MantineThemeContext = createContext(DEFAULT_THEME);
function useMantineTheme() {
  return useContext(MantineThemeContext) || DEFAULT_THEME;
}
function MantineProvider({ theme, children }) {
  return /* @__PURE__ */ React.createElement(SsrProvider, null, /* @__PURE__ */ React.createElement(MantineThemeContext.Provider, {
    value: mergeTheme(DEFAULT_THEME, theme)
  }, children));
}
MantineProvider.displayName = "@mantine/core/MantineProvider";

export { MantineProvider, useMantineTheme };
//# sourceMappingURL=MantineProvider.js.map
